<script setup>
import SmallCardTonalSplash from './SmallCardTonalSplash.vue'
import FeatureTonalSplash from './FeatureTonalSplash.vue'
import VerticalSplash from './VerticalSplash.vue'

// Public entry point for every jk-21 illustration-card family. `family`
// picks which internal component renders; `variation`/`contentSide` are
// forwarded only to the two families that accept them ('vertical' has a
// single shape, no variation/flip) — `colour` always forwards, resolved
// against each family's own colour registry (ILLUSTRATION_COLOURS for
// smallCardTonal/vertical, FEATURE_CARD_COLOURS for featureTonal — see
// SmallCardTonalSplash.vue/FeatureTonalSplash.vue/VerticalSplash.vue).
defineProps({
  family: {
    type: String,
    required: true,
    validator: (v) => ['smallCardTonal', 'featureTonal', 'vertical'].includes(v),
  },  // 'smallCardTonal' | 'featureTonal' | 'vertical'
  variation:   { type: String },                  // smallCardTonal | featureTonal only — those components require it
  colour:      { type: String, default: 'pink' },
  contentSide: { type: String, default: '' },     // smallCardTonal | featureTonal only
})
</script>

<template>
  <SmallCardTonalSplash
    v-if="family === 'smallCardTonal'"
    :variation="variation"
    :colour="colour"
    :contentSide="contentSide"
  />
  <FeatureTonalSplash
    v-else-if="family === 'featureTonal'"
    :variation="variation"
    :colour="colour"
    :contentSide="contentSide"
  />
  <VerticalSplash v-else :colour="colour" />
</template>
